<template>
  <div>
    <div class="row">
      <div class="col-xs-12">
        <h2 class="island">
          {{ lang.get('judging.fast_start.judges.title') }}
        </h2>
      </div>
      <div class="col-xs-12">
        <div class="panel panel-default">
          <div class="panel-body">
            <judge-selector
              id="judge-selector"
              class="judge-selector"
              :recommend-roles="recommendRoles"
              :roles="roles"
              :url="judgeSelectorUrl"
              :create-new-judges="true"
              :type="panelConfig('appliedJudges')"
              :existing-or-new="panelConfig('existingOrNew')"
              :selected-roles="panelConfig('roleIds') || []"
              :init-selected-judges="panelConfig('judges') || []"
              :guest-role-warning="true"
              v-bind="$attrs"
              @typeSelected="
                (appliedJudges, existingOrNew) =>
                  onInput({ appliedJudges, existingOrNew })
              "
              @rolesSelected="roleIds => onInput({ roleIds })"
              @judgesSelected="onJudgesSelected"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <div class="panel panel-default">
          <div class="panel-body">
            <div class="checkbox styled">
              <input
                id="add-myself"
                name="addMyself"
                :value="panelConfig('addMyself') || false"
                :checked="panelConfig('addMyself') || false"
                type="checkbox"
                @change="event => onInput({ addMyself: event.target.checked })"
              />
              <label for="add-myself">
                {{ lang.get('judging.fast_start.judges.add_myself') }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <navigation v-on="$listeners" />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { Multiselect } from 'vue-bootstrap';
import JudgeSelector from '@/lib/components/Judging/JudgeSelector';
import Navigation from '../Navigation';

export default {
  inject: ['lang'],
  components: {
    Multiselect,
    Navigation,
    JudgeSelector
  },
  props: {
    judgingMode: {
      type: String,
      default: 'vip_judging'
    },
    roles: {
      type: Array,
      default: () => []
    },
    judgeSelectorUrl: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters('judgingFastStart', ['panel']),
    recommendRoles() {
      return ['top_pick', 'voting', 'gallery'].includes(this.judgingMode);
    }
  },
  methods: {
    ...mapMutations('judgingFastStart', ['setPanel']),
    onInput(input) {
      this.setPanel({ ...this.panel, ...input });
    },
    getJudgeIds(judges) {
      return judges.filter(judge => judge.name !== null).map(judge => judge.id);
    },
    getEmails(judges) {
      return judges
        .filter(judge => judge.name === null)
        .map(judge => judge.title);
    },
    onJudgesSelected(judges, roleIds) {
      this.setPanel({
        ...this.panel,
        judges: judges,
        judgeIds: this.getJudgeIds(judges),
        emails: this.getEmails(judges),
        emailsRoleIds: roleIds
      });
    },
    panelConfig(config) {
      return (this.panel || {})[config];
    }
  }
};
</script>
